import { Button, Col, Form, List, Row, Select, Tooltip, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import swapElements from "../../../utilities/swapElements";
import { SORT_DIRECTION_LIST } from "./constants";
import sortFields from "./sortFields";
import { isArray } from "lodash-es";

const ResolutionsField = ({ handleSetConfiguration, configuration, fieldName, title, titleTooltip }) => {
  const { formatMessage } = useIntl();
  const [resolutionsList, setResolutionsList] = useState(configuration?.[fieldName] || []);
  const [controlResolutionsInput, setControlResolutionsInput] = useState({
    sortField: "byes",
    sortDirection: "ASC",
  });

  useEffect(() => {
    const data = configuration;
    if (isArray(resolutionsList)) {
      data[fieldName] = resolutionsList;
    } else {
      data[fieldName] = [];
    }
    handleSetConfiguration(data);

    const resolutionActive = Object.entries(sortFields)?.filter((item) => {
      return !resolutionsList?.filter((sortingItem) => item?.[0] === sortingItem?.sortField)?.length;
    })?.[0]?.[0];

    setControlResolutionsInput((prev) => {
      return {
        ...prev,
        sortField: resolutionActive,
      };
    });
  }, [resolutionsList, configuration, fieldName, handleSetConfiguration]);

  const changeSort = useCallback(
    (value, field) => {
      setControlResolutionsInput((prev) => ({ ...prev, [field]: value }));
    },
    [setControlResolutionsInput],
  );

  const handleAddSorting = useCallback(() => {
    setResolutionsList((prev) => [
      ...prev,
      {
        sortField: controlResolutionsInput?.sortField,
        sortDirection: controlResolutionsInput?.sortDirection,
      },
    ]);
  }, [setResolutionsList, controlResolutionsInput?.sortField, controlResolutionsInput?.sortDirection]);

  const handleSwapItems = useCallback(
    (oldIndex, newIndex) => {
      setResolutionsList((prev) => swapElements(prev, oldIndex, newIndex));
    },
    [setResolutionsList],
  );

  const handleRemoveSortingItem = useCallback(
    (index) => {
      setResolutionsList((prev) => [...prev.filter((item, key) => key !== index)]);
    },
    [setResolutionsList],
  );

  return (
    <>
      <Row>
        <Col offset={10}>
          <Tooltip title={titleTooltip}>
            <Typography.Title level={5}>{title}</Typography.Title>
          </Tooltip>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label={"Sort Field"}>
            <Select
              showSearch={true}
              value={controlResolutionsInput?.sortField}
              onChange={(value) => changeSort(value, "sortField")}
            >
              {Object.entries(sortFields)
                ?.filter((item) => {
                  return !resolutionsList?.filter((sortingItem) => item?.[0] === sortingItem?.sortField)?.length;
                })
                ?.map((item) => (
                  <Select.Option key={item?.[0]} value={item?.[0]}>
                    {item?.[1]}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label={"Sort Direction"}>
            <Select
              value={controlResolutionsInput?.sortDirection}
              onChange={(value) => changeSort(value, "sortDirection")}
            >
              {SORT_DIRECTION_LIST?.map((item) => (
                <Select.Option key={item?.value} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={14} offset={10}>
          <Button type={"primary"} onClick={() => handleAddSorting()}>
            {formatMessage({
              id: "add",
              defaultMessage: "Add",
            })}
          </Button>
        </Col>
        <Col span={17} offset={6}>
          {resolutionsList?.length ? (
            <List
              size="small"
              bordered
              dataSource={resolutionsList}
              renderItem={(item, index) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div>
                    <Button
                      onClick={() => handleSwapItems(index, index - 1)}
                      disabled={index === 0}
                      icon={<i className={"fas fa-arrow-up"} />}
                    />
                    <Button
                      onClick={() => handleSwapItems(index, index + 1)}
                      disabled={index === resolutionsList?.length - 1}
                      icon={<i className={"fas fa-arrow-down"} />}
                    />
                    {sortFields?.[item?.sortField]} ({item?.sortDirection})
                  </div>
                  <Button
                    onClick={() => handleRemoveSortingItem(index)}
                    type={"text"}
                    icon={<i className={"fas fa-trash-can text-danger"} />}
                  ></Button>
                </div>
              )}
            />
          ) : (
            ""
          )}
        </Col>
      </Row>
    </>
  );
};

export default ResolutionsField;
